var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-planning-card"},[_c('div',{staticClass:"l-planning-card__header"},[_c('p',{staticClass:"l-planning-card__message",class:{
        'l-planning-card__message--warn': _vm.userActionStatus.status === 'error',
      }},[_vm._v(" "+_vm._s(_vm.userActionStatus.message)+" ")])]),_c('PlanningCardScenariosTab')],1)}
var staticRenderFns = []

export { render, staticRenderFns }